<template>
    <article class="herd-card">
        <header class="herd-card__header">
            <h5 class="herd-card__title" :title="system.name">{{ system.name }}</h5>
            <span v-if="isLoading" class="herd-card__badge">{{ $t('Loading') }}</span>
        </header>

        <div class="herd-card__body" :style="{ minHeight: chartHeight + 'px' }">
            <!-- Wykres montujemy od razu - SciChart potrzebuje kontenera o znanym rozmiarze,
                 wiec zaslepke nakladamy na niego zamiast podmieniac go przez v-if. -->
            <sci-chart-herd-weight
                :key="chartKey"
                :sid="system.id"
                :systemId="system.id"
                :height="chartHeight"
                class="herd-card__chart"
                @loaded="onLoaded"
                @failed="onFailed"/>

            <div v-if="!isReady" class="herd-card__overlay">
                <chart-skeleton v-if="isLoading" :height="chartHeight"/>
                <div v-else class="herd-card__message">
                    <span>{{ message }}</span>
                    <button v-if="isFailed" type="button" class="herd-card__retry" @click="reload">
                        {{ $t('Retry') }}
                    </button>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
import SciChartHerdWeight from '../Charts/SciChartHerdWeight.vue'
import ChartSkeleton from '../Charts/ChartSkeleton.vue'

export default {
    name: 'SystemHerdWeightCard',
    components: {
        SciChartHerdWeight,
        ChartSkeleton
    },
    props: {
        system: {
            type: Object,
            required: true
        },
        chartHeight: {
            type: Number,
            default: 260
        }
    },
    data() {
        return {
            // loading -> ready | empty | failed
            state: 'loading',
            // Zmiana klucza wymusza przemontowanie wykresu przy ponownej probie.
            chartKey: 0
        }
    },
    computed: {
        isLoading() {
            return this.state == 'loading';
        },
        isReady() {
            return this.state == 'ready';
        },
        isFailed() {
            return this.state == 'failed';
        },
        message() {
            return this.isFailed ? this.$t('HerdWeightLoadFailed') : this.$t('HerdWeightNoData');
        }
    },
    methods: {
        onLoaded(result) {
            this.state = result != null && result.isEmpty ? 'empty' : 'ready';
        },
        onFailed() {
            this.state = 'failed';
        },
        reload() {
            this.state = 'loading';
            this.chartKey++;
        }
    }
}
</script>

<style scoped>
.herd-card {
    display: flex;
    flex-direction: column;
    color: white;
    padding: 10px 12px;
    background: #414F51;
    border: 1px solid #30383a;
    border-radius: 5px;
    transition-duration: 0.5s;
}

.herd-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 5px;
}

.herd-card__title {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.herd-card__badge {
    flex-shrink: 0;
    font-size: 12px;
    color: #b7c2c3;
}

.herd-card__body {
    position: relative;
}

.herd-card__chart {
    position: relative;
}

/* Zaslepka i komunikaty przykrywaja plotno, zeby SciChart caly czas mial kontener. */
.herd-card__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #414F51;
}

.herd-card__message {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    color: gray;
    font-size: 14px;
    text-align: center;
    padding: 0 10px;
}

.herd-card__retry {
    color: white;
    background: #30383a;
    border: 1px solid #253032;
    border-radius: 5px;
    padding: 4px 12px;
    font-size: 13px;
    cursor: pointer;
}

.herd-card__retry:hover {
    background: #253032;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/SystemHerdWeightCard.vue